<template>
    <div id="nav">
      <div class="container">
        <div class="logo"><img src="../assets/logo.png" alt="logo"></div><div class="title">
          <div class="name">汤圆记账</div>
          <div class="slogan">家庭财务小管家</div>
          </div>
        <div class="router">
          <router-link to="/">首页</router-link>
          <router-link v-if="!accessToken" to="/login">登录<!--<span class="tag">[导入]</span>--></router-link>
          <router-link v-if="accessToken" to="/user/info">用户中心</router-link>
        </div>
        
      </div>
    </div>
</template>

<script>
export default {
  name: 'Login',
  components: {
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  },
  computed:{
    accessToken() {
      return this.$store.state.accessToken;
    },
  },
  watch: {
  }
}
</script>

<style scoped lang="scss">
@import '@/scss/public.scss';

#nav {
  height: 58px;
  line-height: 58px;
  background: $color-white;
  border-bottom: 1px solid $color-split-line;

  .container {
    display: -webkit-box;
  }

  .logo {
    display: block;
    font-size: 0;
    margin-right: 5px;

    img {
      width: 48px;
      height: 48px;
      vertical-align: middle;
    }
  }

  .title {
    display: -webkit-box;
    -webkit-box-flex: 1;
    -webkit-box-orient: vertical;
    cursor: default;
    line-height: 20px;
    padding-top: 10px;
    .name {
      font-size: 18px;
    }
    .slogan {
      font-size: 11px;
      color: #666666;
    }
  }

  .router {
    font-size: 16px;
    a {
      display: inline;
      margin: 0 20px;
      font-weight: bold;
      color: $color-black;
      text-decoration: none;
      .tag {
        display: inline;
        padding: 2px 4px;
        font-size: 10px;
        color: $color-gray;
      }
    }
    a.router-link-exact-active {
      color: $color-type-income;
    }
  }

}
</style>
